// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"5c8f6909","322":"a7b35d87","385":"2155fa37","585":"176b2d73","815":"89ab5220","862":"fafcaffe"}[chunkId] + ".chunk.js";
};